import { withLeaflet } from "react-leaflet";
import { Marker } from "react-leaflet";
import { Marker as LeafletMarker } from 'leaflet-rotatedmarker';  // Do not delete it

const RotatedMarker = (props) => {
  const setupMarker = (marker) => {
    try {
      if (!marker) return;
      const m = marker.leafletElement; // Leaflet Marker

      // Rotation (from leaflet-rotatedmarker plugin)
      if (props.rotationAngle !== undefined && props.rotationAngle !== null) {
        m.setRotationAngle(props.rotationAngle);
      }
      m.setRotationOrigin(props.rotationOrigin || 'center');

      // Attach Leaflet event handlers (v2 doesn't use `eventHandlers` prop)
      if (props.eventHandlers && !m.__hoverHandlersAttached) {
        Object.entries(props.eventHandlers).forEach(([evt, handler]) => {
          if (typeof handler === 'function') m.on(evt, handler);
        });
        m.__hoverHandlersAttached = true; // prevent duplicate binds
      }
    } catch (error) {
      console.error('Error in RotatedMarker setupMarker:', error);
    }
  };

  try {
    return (
      <Marker
        ref={(el) => setupMarker(el)}
        {...props} // pass position, icon, etc.
      />
    );
  } catch (error) {
    console.error('Error rendering RotatedMarker:', error);
    return null;
  }
};

RotatedMarker.defaultProps = {
  rotationOrigin: 'center',
};

export default withLeaflet(RotatedMarker);